import { CHECK_STATUS } from "./schedulePreviewChecklist";

const CHECK_IMPACTS = {
  "Schedule setup saved":
    "The schedule cannot be published until setup is saved.",
  "Treatment groups configured":
    "Multi-group studies cannot go live without enough treatment groups.",
  "Group names saved":
    "Visit groups cannot be assigned correctly until group names are saved.",
  "Visits configured":
    "At least one visit is required before publishing.",
  "Visit saved":
    "Optional visit setup cannot be completed until the visit is saved.",
  "Visit time point":
    "Visit scheduling and go-live will stay blocked until dates or windows are set.",
  "E-communication":
    "Participants will not receive booking or reminder messages for this visit.",
  "Planner setup":
    "e-Planner cannot book appointments for this visit.",
  "Visit payment":
    "Payment amounts for this visit will be missing in finance records.",
  "Visit cost":
    "Visit cost reports will be incomplete for this visit.",
  "Visit cost & randomisation cost":
    "Visit and randomisation costing cannot be calculated for screening.",
  Documents:
    "Visit documents will not be available to site staff. This is optional for go-live.",
  "Adhoc visit": "Adhoc setup is optional for go-live.",
};

function matchStructureImpact(label = "") {
  if (label.includes("visit structure")) {
    return "Invalid visit names or order will block publishing.";
  }
  if (label.includes("visits saved to database")) {
    return "Unsaved visits cannot be included in a live schedule.";
  }
  return "";
}

export function resolveCheckImpact(label = "", status = "") {
  if (status === CHECK_STATUS.COMPLETE || status === CHECK_STATUS.SKIPPED) {
    return "";
  }

  return (
    CHECK_IMPACTS[label] ||
    matchStructureImpact(label) ||
    "This must be completed before the schedule can go live."
  );
}
